import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../components/loader';
import { useAppSelector } from '../../../app/hooks';
import { selectUser } from '../../../services/accountSlice';
import { createApiToken, fetchApiTokens, selectApiTokens, clearNewlyCreatedToken } from './apiTokensSlice';
import { useGetResourcesQuery } from '../../../services/roleApi';
import { useProjectsQuery } from '../../../services/projectApi';
import ApiTokenForm from './apiTokenForm';
import NewTokenDisplay from './NewTokenDisplay';
import Errors from '../../../components/errors';
import { FormMode, SpecificProjectPermission } from './types';

const AddApiTokenContainer: React.FC = () => {
  const dispatch = useDispatch<any>();  
  const { loading, saving, newlyCreatedToken, error } = useSelector(selectApiTokens);

  const currentUser = useAppSelector(selectUser);

  const { data: resources, isLoading: resourcesIsLoading } = useGetResourcesQuery();
  const showSpecificProjects = resources?.showSpecificProjects ?? false;
  const { data: projectResponse, isLoading: projectsIsLoading } = useProjectsQuery(currentUser?.clientId ?? "", {
      skip: !currentUser?.clientId && !showSpecificProjects
    });

  const handleCreate = async (name: string, expiryDate: string, timezone: string, checkedResources: string[], selectedProjects: SpecificProjectPermission[]): Promise<boolean> => {
    try {
      const res = await dispatch(createApiToken({ name, expires: expiryDate, timezone, resources: checkedResources, projects: selectedProjects })).unwrap();
      if (res?.success) {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  return (
    <div className="container" style={{ padding: 16 }}>
      {(loading || resourcesIsLoading || projectsIsLoading) && <Loader />}
      <h2>Add API Token</h2>      
      <Errors error={error} />
      {newlyCreatedToken && 
      <div>
        <NewTokenDisplay token={newlyCreatedToken} onClose={() => dispatch(clearNewlyCreatedToken())} />
        <button className="button" onClick={() => window.location.href = '/user/api-tokens'}>Back to Token List</button>
      </div>}
      {!newlyCreatedToken && 
        <ApiTokenForm 
          saving={saving} 
          onSave={handleCreate} 
          editMode={FormMode.Add} 
          controllers={resources?.controllers} 
          projects={projectResponse?.projects} 
          showSpecificProjects={showSpecificProjects} />  }
    </div>
  );
};

export default AddApiTokenContainer;
